import { Injectable } from "@angular/core";
import {
  Headers,
  Http,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

@Injectable()
export class MasterDataService {
  constructor(private httpClient: HttpClient) {}
  getSalutations() {
    const query: any = {};
    query.order = "createdAt" + " " + "ASC";
    const filter = new HttpParams().set("filter", JSON.stringify(query));
    return this.httpClient.get("Salutations");
  }

  getOrganizationSubscription(filter) {
    filter.dataFilterType = JSON.stringify(filter.dateFilterType);
    return this.httpClient.get(
      `TokenTransactions/organization-subs-list?dateFilterType=${JSON.stringify(
        filter.dateFilterType
      )}&limit=${filter.limit}&skip=${filter.skip}`
    );
  }
  getOrganizationSubscriptionPurchases(filter, Id) {
    return this.httpClient.get(
      `TokenTransactions/subscription-list/${Id}?dateFilterType=${JSON.stringify(
        filter.dateFilterType
      )}&limit=${filter.limit}&skip=${filter.skip}`
    );
  }
  getSubscriptionDetails(subscriptionId) {
    // const filter: any = {};
    return this.httpClient.get(
      `SubscriptionMasters/packages/${subscriptionId}`, {
    });
  }
  getGeographies() {
    return this.httpClient.get("Geographies");
  }

  getIndustries() {
    const query: any = {};
    query.order = `industryName ASC`;
    const filter = new HttpParams().set('filter',JSON.stringify(query));
    return this.httpClient.get("Industries", {params: filter});
  }

  getJobTitles() {
    return this.httpClient.get("JobTitles");
  }

  getEmployeeSizes() {
    return this.httpClient.get("EmployeeSizes/getList");
  }

  getRevenues() {
    return this.httpClient.get("Revenues/getList");
  }

  getCountries() {
    const query: any = {};
    query.order = "countryName" + " " + "ASC";
    const filter = new HttpParams().set("filter", JSON.stringify(query));
    return this.httpClient.get("Countries", { params: filter });
  }

  getItBudgets() {
    return this.httpClient.get("ItBudgets/getList");
  }

  getLineOfBusinesses() {
    return this.httpClient.get("LineOfBusinesses");
  }

  getOrganizationsList() {
    const query: any = {};
    query.order = `name ASC`;
    const filter = new HttpParams().set('filter',JSON.stringify(query));
    return this.httpClient.get("Organizations", {params: filter});
  }

  getUserslist(id: string, search: string) {
    return this.httpClient.get(
      `UserRoleViews/organization-vendor-list/${id}/?&search=${search}`
    );
  }

  invoiceSubscription(id: string, subscriptionPayload: any) {
    return this.httpClient.post(
      `Subscriptions/add-invoice-for-vendor/${id}`,
      subscriptionPayload
    );
  }

  setExpiryDate(subscriptionMasterId, expiryDate, isExpired) {
    // const filter: any = {};
    return this.httpClient.patch(
      `SubscriptionMasters/set-new-expiry-date?id=${subscriptionMasterId}&newExpiryDate=${expiryDate}&isExpired=${isExpired}`, {
    });
  }
  setTokenAmount(subscriptionMasterId, tokenAmount) {
    // const filter: any = {};
    return this.httpClient.patch(
      `SubscriptionMasters/set-new-token-amount?id=${subscriptionMasterId}&newTokenAmount=${tokenAmount}`, {
    });
  }
  setSubscriptionTypeAndPrice(subscriptionMasterId, newSubscriptionType, finalPrice) {
    return this.httpClient.patch(
      `SubscriptionMasters/set-type-price?id=${subscriptionMasterId}&subsType=${newSubscriptionType}&finalPrice=${finalPrice}`, {
    });
  }

  getUserDetails(id: string) {
    return this.httpClient.get(`users/${id}/profile`);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/master-data.service.ts